import React, { useState, useEffect } from "react";
import { Box, Container, Grid, Typography } from "@mui/material";
import { AnimatePresence, motion } from "framer-motion";
import FunctionCard from "../components/FunctionCard";
import FunctionDetails from "../components/FunctionDetails";
import { useTranslation } from "react-i18next";

const FunctionPage = () => {
  
  const { t, i18n } = useTranslation();

  useEffect(() => {
    if (selected) {
      const updatedList = t("functions.list", { returnObjects: true });
      const updatedFunc = updatedList.find(f => f.id === selected.id);
      if (updatedFunc) setSelected(updatedFunc);
    }
  }, [i18n.language]);

  const [selected, setSelected] = useState(null);

  const functions = t("functions.list", { returnObjects: true });

  return (
    <Box sx={{ backgroundColor: "#FFF8E1", py: 8, minHeight: "100vh" }}>
      <Container maxWidth="xl">
        {!selected ? (
          <>
            <Typography
              variant="h3"
              align="center"
              sx={{
                fontWeight: 700,
                mb: 6,
                color: "#000",
                textShadow: "0 0 10px rgba(212,175,55,0.6)",
              }}
            >
              {t("functions.title")}
            </Typography>

            <Grid container spacing={4} justifyContent="center">
              {functions.map((func, i) => (
                <Grid item xs={12} sm={6} md={4} key={i}>
                  <FunctionCard
                    title={func.title}
                    image={func.image}
                    onClick={() => setSelected(func)}
                  />
                </Grid>
              ))}
            </Grid>
          </>
        ) : (
          <AnimatePresence>
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: 30 }}
              transition={{ duration: 0.8 }}
            >
              <FunctionDetails func={selected} />
              <Box sx={{ textAlign: "center", mt: 4 }}>
                <Box
                  onClick={() => setSelected(null)}
                  sx={{
                    display: "inline-block",
                    px: 4,
                    py: 1.4,
                    fontWeight: 700,
                    cursor: "pointer",
                    borderRadius: "30px",

                    // 🖤 Black background
                    background: "#000",

                    // ✨ Golden text
                    color: "#D4AF37",

                    fontSize: "1.1rem",
                    letterSpacing: "0.5px",

                    // 🌟 Golden border
                    border: "2px solid #D4AF37",

                    transition: "all 0.3s ease",

                    // 💫 Hover effect (gold glow)
                    "&:hover": {
                      background: "#000",
                      color: "#FFD966",
                      boxShadow: "0 0 15px rgba(212,175,55,0.6)",
                      transform: "translateY(-3px)",
                    },

                    // 🖱 Active click effect
                    "&:active": {
                      transform: "scale(0.96)",
                    }
                  }}
                >
                  {t("functions.backButton")}
                </Box>
              </Box>

            </motion.div>
          </AnimatePresence>
        )}
      </Container>
    </Box>
  );
};

export default FunctionPage;
